export default __webpack_public_path__ + "media/zurb/fonts/ProximaNova-Extrabold-2f3072d4626871ea46208999e7ad31cd.woff2";